import { c as _c } from "react/compiler-runtime";
import { ReactElement, memo, useState } from 'react';
import ImageComponent from '@spa/components/image-component/image.component';
import type { ProductInfoProductImage } from '@spa/components/product-info/ProductInfoProductTypes';
import { StickyBuyRowPosition } from './StickyBuyRowPosition';
import classNames from 'clsx';
import { fallbackProductImage } from '@spa/lib/const';
import styles from './sticky-buy-button.component.module.scss';
import { useStickyBuyRowVisibility } from './useStickyBuyRowVisibility';
export interface Props {
  readonly productImage: ProductInfoProductImage | null;
  readonly productDisplayName: string;
  readonly productPriceComponent: ReactElement;
  readonly addToCartComponent: (position: StickyBuyRowPosition) => ReactElement;
  readonly position: StickyBuyRowPosition | null;
}
function StickyBuyButtonComponent(t0) {
  const $ = _c(29);
  const {
    productImage,
    productDisplayName,
    productPriceComponent,
    addToCartComponent,
    position
  } = t0;
  const [lastPosition, setLastPosition] = useState(null);
  const isVisible = position !== null;
  const {
    isRendered,
    onAnimationEnd
  } = useStickyBuyRowVisibility(isVisible);
  const shownPosition = position ?? lastPosition;
  if (position !== null && position !== lastPosition) {
    setLastPosition(position);
  }
  if (!isRendered || shownPosition === null) {
    return null;
  }
  const t1 = styles[`sticky-buy-row--${shownPosition}`];
  const t2 = !isVisible;
  let t3;
  if ($[0] !== t1 || $[1] !== t2) {
    t3 = classNames(styles["sticky-buy-row"], t1, {
      [styles["sticky-buy-row--hidden"]]: t2
    });
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = productImage?.url ?? fallbackProductImage.url;
  const t5 = productImage?.width ?? fallbackProductImage.width;
  const t6 = productImage?.height ?? fallbackProductImage.height;
  let t7;
  if ($[3] !== productDisplayName || $[4] !== t4 || $[5] !== t5 || $[6] !== t6) {
    t7 = <ImageComponent className={styles["sticky-buy-row__product-image"]} src={t4} alt={productDisplayName} width={t5} height={t6} />;
    $[3] = productDisplayName;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== productDisplayName) {
    t8 = <span className="body-bold">{productDisplayName}</span>;
    $[8] = productDisplayName;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t7 || $[11] !== t8) {
    t9 = <div className={styles["sticky-buy-row__details-wrapper"]}>{t7}{t8}</div>;
    $[10] = t7;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== productPriceComponent) {
    t10 = <div className={styles["sticky-buy-row__price-wrapper"]}>{productPriceComponent}</div>;
    $[13] = productPriceComponent;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== addToCartComponent || $[16] !== shownPosition) {
    t11 = addToCartComponent(shownPosition);
    $[15] = addToCartComponent;
    $[16] = shownPosition;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t11) {
    t12 = <div className={styles["sticky-buy-row__button-wrapper"]}>{t11}</div>;
    $[18] = t11;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t10 || $[21] !== t12 || $[22] !== t9) {
    t13 = <div className={styles["sticky-buy-row__inner-wrapper"]}>{t9}{t10}{t12}</div>;
    $[20] = t10;
    $[21] = t12;
    $[22] = t9;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== onAnimationEnd || $[25] !== shownPosition || $[26] !== t13 || $[27] !== t3) {
    t14 = <div key={shownPosition} className={t3} onAnimationEnd={onAnimationEnd}>{t13}</div>;
    $[24] = onAnimationEnd;
    $[25] = shownPosition;
    $[26] = t13;
    $[27] = t3;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  return t14;
}
export default memo(StickyBuyButtonComponent);